<template>
    <div>
        <the-header>
            <template v-slot:title>
                {{ $route.meta.title }}
            </template>
        </the-header>
        <section class="section">
            <div
                class="container"
                v-if="loadingStatus == 'loading'"
            >
                <div class="columns">
                    <div class="column has-text-centered">
                        <br />
                        <h1 class="title">Trwa pobieranie reklamacji</h1>
                        <svg-icon
                        class="svg svg-icon--background svg-icon__icon--loader"
                        type="return"
                        />
                    </div>
                </div>
            </div>
            <div
                class="container"
                v-else-if="complaints"
            >
                <the-complaints
                    v-for="(complaint, index) in complaints"
                    v-bind:key="index"
                    :complaint="complaint"
                />
            </div>
            <div class="container" v-else>
                <div class="columns">
                    <div class="column has-text-centered">
                        <br />
                        <h1 class="title">Brak reklamacji</h1>
                        <svg-icon
                            class="svg svg-icon--background"
                            type="box"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheComplaints from '@/components/TheComplaints'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Complaints',
    components: {
        'the-complaints': TheComplaints,
        'the-header': TheHeader,
        'svg-icon': SvgIcon
    },
    metaInfo: {
        title: 'Reklamacje'
    },
    data(){
        return {
            showModal: true,
        }
    },
    computed: {
        loadingStatus(){
            return this.$store.getters.getComplaintsLoadingStatus
        },
        complaints(){
            return this.$store.getters.getComplaints
        }
    },
    created(){
        this.$store.dispatch('fetchComplaints')
    }
}
</script>
<style lang="sass" scoped>
.section
    padding-bottom: 50vh
</style>
